let aduio = {
  callNet: {
    //语音拨话

    /***基本语音呼叫，呼叫单个用户。具体呼叫结果（是否摘机应答）不在调用响应结果中体现，通过推送号码状态通知判断呼叫结果
    （其他的语音服务接口都类似，直接的响应结果并不包含实际的操作结果，通过通知的方式反馈具体状态）**/
    url: '/dispatch-web/api/call/makeCall',
    requestParam: {
      token: '',
      caller: '',
      //主叫号码（一般使用坐席号码）
      callee: '',
      //被叫号码
      businessId: '',
      //业务Id，用于业务操作与相关功能的关联
      isRecord: '' //是否录音 预留字段

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: ''
    }
  },
  answerNet: {
    //对拨入的号码进行选择性的应答

    /***对呼入列表中的某一号码做应答优先设置，坐席设备摘机后会自动与选择的号码建立通话**/
    url: '/dispatch-web/api/call/answer',
    requestParam: {
      token: '',
      tel: '',
      //呼入队列中的某一号码
      businessId: '' //业务Id，用于业务操作与相关功能的关联

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: ''
    }
  },
  holdNet: {
    //保持通话

    /***保持通话，对与坐席号码进行通话的号码进行保持，保持后如果通话有录音则录音结束**/
    url: '/dispatch-web/api/call/hold',
    requestParam: {
      token: '',
      tel: '' //呼入队列中的某一号码

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: ''
    }
  },
  unholdNet: {
    //取消保持通话恢复通话

    /***恢复通话，可以使被保持号码通话
     * 主叫号码可以指定任意其他号码，非必须是上次通话的号码
     * 如果通话有录音，新产生录音记录
    **/
    url: '/dispatch-web/api/call/unhold',
    requestParam: {
      token: '',
      caller: '',
      //主叫号码（一般使用坐席号码）
      callee: '' //被保持号码

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: ''
    }
  },
  transferNet: {
    //通话转接，由操作员操作转接

    /***将正在与操作员通话的号码转接到其他号码，实现两个号码的通话连接。
     * 转接成功后操作员号码话机可挂机
    **/
    url: '/dispatch-web/api/call/transfer',
    requestParam: {
      token: '',
      from: '',
      //被转接号码（与操作员通话的号码）
      to: '',
      //转接到号码
      businessId: ''
    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: ''
    }
  },
  retrieveNet: {
    //取消转接

    /***取消到某个号码的转接动作,
     * 该接口只支持在转接过程中的操作，转接成功后无法取消转接
    **/
    url: '/dispatch-web/api/call/retrieve',
    requestParam: {
      token: '',
      tel: '' //转接到号码

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: ''
    }
  },
  tripleBreakinNet: {
    //强插

    /***针对状态监测的用户(未经过调度的双方通话)，可以执行
      强插等操作。
      如操作员A，用户B和C正在通话。
      A【强插】B或C，ABC进行三方通话
    **/
    url: '/dispatch-web/api/call/tripleBreakin',
    requestParam: {
      token: '',
      caller: '',
      //主叫号码 （坐席号码）
      callee: '' //被叫号码，被操作对象

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: ''
    }
  },
  tripleHungupNet: {
    //强拆

    /***针对状态监测的用户(未经过调度的双方通话)，可以执行强拆操作。
      如操作员A，用户B和C正在通话。
      A【强拆】B或C，BC都被拆线
    **/
    url: '/dispatch-web/api/call/tripleHungup',
    requestParam: {
      token: '',
      tel: '' //被拆线号码，被操作对象

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: ''
    }
  },
  tripleMonitorNet: {
    //监听

    /***针对状态监测的用户(未经过调度的双方通话)，可以执行监听操作。
      如操作员A，用户B和C正在通话。
      A【监听】B或C，BC正常通话，A可以听到BC的语音
    **/
    url: '/dispatch-web/api/call/tripleHungup',
    requestParam: {
      token: '',
      caller: '',
      //主叫号码 （坐席号码）
      callee: '' //被叫号码，被操作对象

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: ''
    }
  },
  groupNotifyNet: {
    //组呼通知

    /***1、将一组通知音播放给多个号码，通知音必须先录制。
      通知音查询 请参照 查询通知音 接口。
      通知音上传 请参照 通知音上传 接口，
      2、或者将一段文字，转成语音播放给多个号码。
      3、组呼通知结果以通知的形式告知
    **/
    url: '/dispatch-web/api/call/groupNotify',
    requestParam: {
      token: '',

      /**
       * 1、type != text,则通知语音文件，
        如果多个文件以“,”隔开，最多支持4个录音文件。
        如：5006_12059301042.au,5006_3866025493.au
        2、type = text,
        该字段长度不超过64个中文汉字，128字节。必须为中文。 
       */
      files: '',
      //

      /***
       * 多个成员号码。格式为8000,8001,8002,8003,8004。
        号码数目最多16个。
       */
      tels: '',
      //

      /***
       * notify : 通知音录音。
        call_record : 通话录音。
        text: 文字通知(TTS 文字转语音)
        默认为notify。
       */
      type: '',

      /***
       * 组呼通知记录ID，由客户端（第三方程序）构造，
       * 用于查询组呼通知结果（如不设置将无法对应查找结果）
       * 要求：长度不超过32位，请确保唯一。
        建议用户名+时间戳或随机数。如：scooper_1522381878
       */
      notifyId: '',

      /**
       * 循环播放次数，默认为1次。
        当为-1时，循环播放直到调【结束组呼通知】接口结束
       */
      times: '',

      /**
       * 通知确认音
        格式：{数字}={数字代表含义};{数字}={数字代表含义}，中间用英文分号分隔  
        如：1=确认;2=忽视;3=拒绝
        后台自动将确认文字转换成确认音，并统计回复结果，在组呼通知结果中体现
       */
      confirm: ''
    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: ''
    }
  },
  queryGroupNotifyNet: {
    //分页查询组呼通知结果
    url: '/dispatch-web/api/call/queryGroupNotifyResult',
    requestParam: {
      token: '',
      notifyId: '',
      //通知ID
      caller: '',
      //主叫，发起者用户名
      timeMin: '',
      //开始时间范围最小值(针对通知发起时间tmNotify)
      timeMax: '',
      //开始时间范围最大值(针对通知发起时间tmNotify)
      pageIndex: '',
      pageSize: ''
    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {
        total: '',
        list: [{
          //NotifyRecord
          id: '',
          //组呼通知结果记录ID
          notifyId: '',
          //通知ID
          caller: '',
          //主叫
          callee: '',
          //被通知号码
          tmNotify: '',
          //通知时间
          tmAnswer: '',
          //通知号码应答时间
          tmHangup: '',
          //通知结束时间
          tmLen: '',
          //通知时长，单位“秒”
          notifyType: '',
          //组呼通知类型 0：通知音  2：tts
          files: '',
          //通知内容 notifyType=0  通知音文件名  notifyType=2  tts文本内容

          /**
           * 通知结果。
            200:通知正常;
            489:调度员手动停止;
            487:被叫未听完主动挂机;
            486:遇忙;
            480:暂时无法接通;
            408:无应答;
            404:空号;
            500:未知
           */
          result: '',

          /***
           * 组呼通知反馈结果，根据组呼通知时自定义确认音
            accept: 确认
            refuse：拒绝
            ignore：忽略
           */
          confirm: ''
        }] //记录列表，[0, n]个NotifyRecord

      }
    }
  },
  queryCallNet: {
    //分页查询呼叫记录
    url: '/dispatch-web/api/call/queryCallRecord',
    requestParam: {
      token: '',
      caller: '',
      //主叫
      timeMin: '',
      //开始时间最小值
      timeMax: '',
      //开始时间最大值
      pageIndex: '',
      pageSize: ''
    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {
        total: '',
        list: [{
          //记录列表，[0, n]个CallRecord
          id: '',
          //呼入未接记录ID
          businessId: '',
          //呼叫记录业务id，可用于关联查询通话录音文件
          caller: '',
          //主叫
          callee: '',
          //被叫
          tmCall: '',
          //呼叫发起时间
          tmAnswer: '',
          //应答时间
          tmHangup: '',
          //挂机时间
          tmLen: '',
          //通话时长（单位:秒）

          /**
           * 呼叫类型
              meet: 会议呼叫
              session: 语音呼叫
              callout: 平台呼出      
              callin:  平台呼入 
              incallout: 调度呼出  
              incallin: 调度呼入
           */
          callType: '',

          /**
           * 呼叫结果
            200:呼叫正常;
            486:遇忙;
            408:无应答;
            404:空号;
            500:未知
           */
          result: ''
        }]
      }
    }
  }
};
export default aduio;